import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button, Container } from 'semantic-ui-react';
import * as yup from 'yup';
import moment from 'moment';
import Axios from 'axios';
import { customerCompanyName, customerNameVal, customerLogo } from "../utils/constants";
import AddTitleBar from '../titleBar/addTitleBar';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';
import APP_CONSTANTS from '../../config/constants';


//Inputs
import { DateData } from '../formikInput/date';
import { MyTextArea } from '../formikInput/input';
//Add-Product
import AddProduct from '../salesOrder/addProduct';
import ActivePurchaseOrder from './activePurchaseOrder'

//Dropdowns
import BillingPartyDropdown from '../dropdowns/billingPartyDropdown';
import CustomerBranchDropdown from '../dropdowns/customerBranchDropdown';
import ConsigneeDropdown from '../dropdowns/consigneeDropdown';
import BranchDropdown from '../dropdowns/branchDropdown';
import VendorVehicleDropdown from '../dropdowns/vendorVehicleDropdown';

//Actions 
import { getCustomerInvoice, updateCustomerInvoice } from '../../redux/actions/customerInvoiceActions';
import { getCustomerSalesOrder, setMultiSelectSoData } from '../../redux/actions/salesOrderActions';
import ConsignorDropdown from '../dropdowns/consignorDropdown';


const EditCustomerInvoice = (props) => {

    const { getCustomerInvoice, updateCustomerInvoice, getCustomerSalesOrder, customerSalesOrderData, customerSalesOrderLoading, customerInvoiceData, customerInvoiceLoading, setMultiSelectSoData, customerSalesOrderPagination } = props;
    //State
    const [activateManualPO, setActivateManualPO] = useState(false);
    const [vehicleData, setVehicleData] = useState([]);
    const [customerDetails, setCustomerDetails] = useState({})
    const [customerName, setCustomerName] = useState("");
    const [branchData, setBranchData] = useState([]);

    const getBranchData = childData => {
        setBranchData(childData)
    };

    const getBranchSelected = childData => {
        const branchDetails = branchData.find(data => data.billingPartyBranchCode === childData);
    };
    //UseEffect
    useEffect(() => {
        const id = props.location.state.id
        const edit = true

        const customerData = {
            billingPartyCode: props.location.state.billingPartyCode,
            invoiceId: props.location.state.invoiceId

        }

        getCustomerInvoice('1', '2', '3', id);
        getCustomerSalesOrder(customerData, edit);

    }, [getCustomerInvoice])


    const getCustomerDetails = childData => {
        setCustomerDetails(childData);
    }

    useEffect(() => {
        if (customerInvoiceData && customerInvoiceData?.length > 0) {
            setMultiSelectSoData(customerInvoiceData[0].sales_orders_details)
        } else {
            setMultiSelectSoData([])
        }
    }, [customerInvoiceData, customerSalesOrderData])

    const handleSearchString = (searchString) => {
        const customerData = {
            billingPartyCode: props.location.state.billingPartyCode,
            invoiceId: props.location.state.invoiceId,
            searchString
        }
        const edit = true

        getCustomerSalesOrder(customerData, edit);
    };


    if (customerSalesOrderLoading || customerInvoiceLoading) {
        return (
            <React.Fragment>
                <LoadingPlaceholder />
            </React.Fragment>
        )
    } else {
        //Existing PO Array

        let activeSOData = [];

        customerSalesOrderData && customerInvoiceData && customerSalesOrderData.map((o, i) => {
            let temp = {}

            function containsPoId(obj, list) {
                var i;
                for (i = 0; i < list.length; i++) {
                    if (list[i].sales_orders_id === obj.id) {
                        return true;
                    }
                }

                return false;
            }

            temp.checkbox = containsPoId(o, customerInvoiceData[0].sales_orders_details)
            temp.soId = o.id
            temp.soReferenceNo = o.reference_number
            temp.clientCode = o.client_code
            temp.branchCode = o.branch_code
            temp.vehicleNo = o.vehicle_number
            temp.vehicleId = o.vehicle_id
            temp.soQuantity = o.so_quantity
            temp.soAmount = o.so_amount
            temp.soNumber = o.so_number
            // temp.expectedDeliveryDate = o.expectedDeliveryDate ? o.expectedDeliveryDate : ''
            temp.sgstAmount = o.sgst_amount
            temp.cgstAmount = o.cgst_amount
            temp.igstAmount = o.igst_amount
            temp.adjustment = o.adjustment
            temp.totalOrderAmt = o.total_order_amt
            temp.remarks = o.remarks
            temp.gstTaxType = o.gst_tax_type
            temp.soDate = o.so_date
            temp.tdsAmount = o.tds_amount
            temp.taxableAmount = o.taxable_amount
            temp.totalDiscount = o.total_discount
            temp.lr_date = o.lr_date
            temp.lr_no = o.lr_no
            activeSOData[i] = temp
        })



        //Formik
        const initialValues = {
            customerName: customerInvoiceData ? customerInvoiceData[0].client_code : '',
            consigneeName: customerInvoiceData ? customerInvoiceData[0].consignee_code : "",
            consignorName: customerInvoiceData ? customerInvoiceData[0].consignor_code : "",
            customerBranch: customerInvoiceData ? customerInvoiceData[0].client_branch_name : "",
            consigneeId: customerInvoiceData ? customerInvoiceData[0].consignee_id : '',
            consignorId: customerInvoiceData ? customerInvoiceData[0].consignor_id : '',
            invoiceNumber: customerInvoiceData ? customerInvoiceData[0].invoice_no : '',
            invoiceDate: customerInvoiceData ? new Date(customerInvoiceData[0].invoice_date) : '',
            expectedPaymentDate: customerInvoiceData ? new Date(customerInvoiceData[0].expected_payment_date) : '',
            branch: customerInvoiceData ? customerInvoiceData[0].branch_code : '',
            referenceNo: customerInvoiceData ? customerInvoiceData[0].reference_number : '',
            remarks: customerInvoiceData ? customerInvoiceData[0].remarks : '',
            productDetails: [{
                productName: '',
                startDate: '',
                endDate: '',
                quantity: 1,
                rate: '',
                discount: '',
                discountType: "1",
                iGstPercent: 0,
                iGst: 0,
                cGstPercent: 9,
                cGst: 0,
                sGstPercent: 9,
                sGst: 0,
                amount: 0,
            }],
            activeSODetails: activeSOData,
            finalAmount: '',
            activePOSelected: [],
        }

        const validateSchema = yup.object().shape({
            customerName: yup.mixed().required('Customer Name is Required'),
            consigneeName: yup.mixed().optional(),
            invoiceDate: yup.mixed().required('Invoice Date is Required'),
            customerBranch: yup.mixed().required('Customer Branch is Required'),
            branch: yup.mixed().required('Branch is Required'),
            expectedPaymentDate: yup.mixed().required('Expected Payment Date is Required'),
            referenceNo: yup.mixed().optional(''),
        })

        const onSubmit = (values, onSubmitProps) => {
            const customerNumber = localStorage.getItem('customerNo');
            const userId = localStorage.getItem('userId');

            let psLineItems = [];
            values.productDetails.map((product, index) => {
                let temp = {}
                temp.product_code = product.productCode
                temp.start_date = product.startDate
                temp.end_date = product.endDate
                temp.product_qty = product.quantity
                temp.product_price = product.rate
                temp.product_amount = product.rate * product.quantity
                temp.total_amount = product.amount
                temp.igst_percentage = product.iGstPercent
                temp.igst_amount = product.iGst
                temp.cgst_percentage = product.cGstPercent
                temp.cgst_amount = product.cGst
                temp.sgst_percentage = product.sGstPercent
                temp.sgst_amount = product.sGst
                temp.tds_id = ''
                temp.tds_amount = ''
                temp.pending_tds_amount = ''
                temp.no_of_days = ''
                temp.discount = product.discount
                temp.final_discount = product.discount
                temp.discount_type = product.discountType
                temp.taxable_amount = product.rate * product.quantity
                psLineItems[index] = temp
            });

            let exLineItems = [];
            values.activeSOSelected.map((product, index) => {
                exLineItems.push(product?.soReferenceNo || product?.reference_number)
            })

            // if(activateManualPO){
            //     exLineItems = [];
            // } else {
            //     manualPoArray = [];
            // }

            let loginDtsValue = {
                customerCompanyName,
                customerName: customerNameVal,
                customerLogo,
            };

            const updateCustomerInvoiceData = {
                customer_no: customerNumber,
                user_id: userId,
                consignee_code: values.consigneeName ? values.consigneeName : 0,
                consignor_code: values.consignorName,
                client_code: customerInvoiceData[0].client_code,
                client_branch_code: customerInvoiceData[0].client_branch_code,
                client_branch_id: customerInvoiceData[0].client_branch_id,
                invoice_amt: values.finalAmount,
                status_id: '',
                invoice_quantity: '',
                complete_payment: '',
                expected_payment_date: moment(values.expectedPaymentDate).format("DD-MM-YYYY"),
                reference_number: values.referenceNo,
                invoice_date: moment(values.invoiceDate).format("DD-MM-YYYY"),
                total_so_amt: values.finalAmount,
                trip_memo_no: values.tripMemoNo,
                lr_no: values.lrNo,
                lr_date: values.lrDate,
                terms_conditions: '',
                vehicle_no: values.vehicleNumber,
                remarks: values.remarks,
                branch_code: values.branch,
                gst_tax_type: 2,
                active_so: values.soReferenceNo ? 2 : 1,
                sgst_amount: '',
                cgst_amount: '',
                igst_amount: '',
                so_quantity: psLineItems.length,
                isPartialBill: 0,
                total_order_amt: values.finalAmount,
                pending_amt: values.finalAmount,
                adjustment: 0,
                sales_order_reference_number: values.soReferenceNo,
                so_amount: values.amount,
                tdsAmount: 0,
                taxable_amount: 2,
                total_discount: 0,
                ci_so_reference_numbers: exLineItems,
                products: [],
                loginDts: loginDtsValue,
            };

            updateCustomerInvoice(updateCustomerInvoiceData).then(() => {
                setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
            });

        };

        return (
            <React.Fragment>
                <AddTitleBar title="Edit Customer Invoice" LinkName="/customerinvoice" />
                <div className="m-2">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validateSchema}
                        onSubmit={onSubmit}
                    >
                        {({ touched, errors, values, isSubmitting, handleSubmit }) => (
                            <>
                                <Segment>
                                    <div className="ui form tiny">
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Customer Name</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik
                                                    component={BillingPartyDropdown}
                                                    disabled
                                                    name="customerName"
                                                    placeholder="Customer Name"
                                                    value={values.customerName}
                                                    getCustomerSalesOrder={getCustomerSalesOrder}
                                                    customerMasterCode={values.customerName}
                                                    getCustomerDetails={getCustomerDetails}
                                                    setCustomerName={setCustomerName}
                                                    getBranchData={getBranchData}
                                                />
                                                {touched.customerName && errors.customerName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerName}</strong> : ''}
                                            </FormUi.Field>
                                            {/* <FormUi.Field width="4">
                                                <Fieldmik component={BillingPartyDropdown}
                                                    name="customerName"
                                                    placeholder="Customer Name"
                                                    getBranchData={getBranchData}
                                                    getVendorDetails={getVendorDetails}
                                                    getCustomerSalesOrder={getCustomerSalesOrder}
                                                    setCustomerName={setCustomerName}
                                                    getCustomerDetails={getCustomerDetails}
                                                    setInitialize={setInitialize} />
                                            {touched.customerName && errors.customerName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerName}</strong> : ''}
                                        </FormUi.Field> */}
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Customer Branch<span className='mandatory-star'> *</span></label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik component={CustomerBranchDropdown}
                                                    name="customerBranch"
                                                    placeholder={values.customerBranch}
                                                    value={values.customerBranch}
                                                    branchData={branchData}
                                                    getBranchSelected={getBranchSelected}
                                                />
                                                {touched.customerBranch && errors.customerBranch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerBranch}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Consignee Name</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik
                                                    component={ConsigneeDropdown}
                                                    name="consigneeName"
                                                    placeholder="Consignee Name"
                                                    getVendorPurchaseOrder={getCustomerSalesOrder}
                                                    value={values.consigneeName}
                                                    consigneeMasterId={values.consigneeId}
                                                />
                                                {touched.consigneeName && errors.consigneeName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.consigneeName}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Branch<span className='mandatory-star'> *</span></label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik component={BranchDropdown} name="branch" placeholder="Branch" value={values.branch} />
                                                {touched.branch && errors.branch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.branch}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Consignor Name</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik component={ConsignorDropdown} name="consignorName"
                                                    placeholder="Consignor Name"
                                                    value={values.consignorName}
                                                    branchData={branchData}
                                                    consigneeMasterId={values.consignorId}
                                                />
                                                {touched.consignorName && errors.consignorName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.consignorName}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Invoice Number</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="invoiceNumber" placeholder="Invoice Number" readOnly />
                                                {touched.invoiceNumber && errors.invoiceNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.invoiceNumber}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Credit Period<span className='mandatory-star'> </span></label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik disabled name="creditPeriod" value={customerDetails?.creditPeriod ? customerDetails.creditPeriod : 0} placeholder="Credit Period" />
                                                {touched.creditPeriod && errors.creditPeriod ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.creditPeriod}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Expected Payment Date</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <DateData
                                                    name={`expectedPaymentDate`}
                                                    autoComplete="off"
                                                    popperClassName="dateTime"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Date"
                                                    selected={values.expectedPaymentDate}
                                                    minDate={values.invoiceDate}
                                                    timeIntervals={5}
                                                    customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                />
                                                {touched.expectedPaymentDate && errors.expectedPaymentDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.expectedPaymentDate}</strong> : ''}
                                            </FormUi.Field>


                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Reference Number</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="referenceNo" disabled placeholder="Reference Number" />
                                                {touched.referenceNo && errors.referenceNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.referenceNo}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Invoice Date</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <DateData
                                                    name={`invoiceDate`}
                                                    keyCheck={customerDetails.creditPeriod}
                                                    keyCheckName={`expectedPaymentDate`}
                                                    autoComplete="off"
                                                    popperClassName="dateTime"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Date"
                                                    selected={values.invoiceDate}
                                                    timeIntervals={5}
                                                    customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                />
                                                {touched.invoiceDate && errors.invoiceDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.invoiceDate}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group>

                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Remarks</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik component={MyTextArea} name="remarks" placeholder="Remarks" />
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />

                                        </FormUi.Group>

                                    </div>
                                </Segment>
                                <Segment>
                                    <div className="ui form tiny">

                                        <Button
                                            type="button"
                                            onClick={() => { setActivateManualPO(false) }}
                                            style={{ borderRadius: "5px 5px 0px 0px" }}
                                            size="small"
                                            toggle
                                            active={!activateManualPO}
                                        >
                                            Active Sales Order
                                        </Button>
                                        {/* <Button 
                                            type="button" 
                                            onClick={() => { setActivateManualPO(true)}}
                                            style={{ borderRadius: "5px 5px 0px 0px" }}
                                            size="small"
                                            toggle
                                            active={activateManualPO}

                                        >
                                            New Purchase Order
                                        </Button>
                                        */}
                                        {/* FieldArray Component */}
                                        {activateManualPO ?

                                            <>

                                                <Container className="m-2">
                                                    <FormUi.Group >
                                                        <FormUi.Field width="3">
                                                            <label className="labelName mt-2">Vehicle Number</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="3">
                                                            <Fieldmik component={VendorVehicleDropdown} name="vehicleNumber" placeholder="Vehicle Number" vehicleData={vehicleData} />
                                                            {touched.vehicleNumber && errors.vehicleNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vehicleNumber}</strong> : ''}
                                                        </FormUi.Field>
                                                        <FormUi.Field width="2" />
                                                        <FormUi.Field width="3">
                                                            <label className="labelName mt-2">PO Reference Number</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="3">
                                                            <Fieldmik name="poReferenceNo" placeholder="Reference Number" />
                                                            {touched.poReferenceNo && errors.poReferenceNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.poReferenceNo}</strong> : ''}
                                                        </FormUi.Field>
                                                    </FormUi.Group>
                                                </Container>

                                                <AddProduct />

                                            </>

                                            :

                                            <ActivePurchaseOrder
                                                activeSOData={activeSOData}
                                                editmode={true}
                                                handleSearchStringCall={handleSearchString}
                                                customerCode={values.customerName}
                                                customerSalesOrderPagination={customerSalesOrderPagination}
                                            />}
                                    </div>

                                </Segment>
                                <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit'>Submit</Button></center>
                            </>
                        )}
                    </Formik>
                </div>
            </React.Fragment>
        )
    }
}

const mapStatetoProps = state => ({
    customerSalesOrderData: state.getCustomerSalesOrderData.customerSalesOrder.data,
    customerSalesOrderPagination: state.getCustomerSalesOrderData.customerSalesOrder.pagination,
    customerSalesOrderLoading: state.getCustomerSalesOrderData.isLoading,
    customerInvoiceData: state.getCustomerInvoiceData.customerInvoice.data,
    customerInvoiceLoading: state.getCustomerInvoiceData.isLoading,
})

export default connect(mapStatetoProps, { updateCustomerInvoice, getCustomerSalesOrder, getCustomerInvoice, setMultiSelectSoData })(EditCustomerInvoice)


